import React from "react";

import {
	getRadians,
	isBetClosed,
} from "@/modules/commonMobile";

import moneyFormat from "@/modules/moneyFormat";

import "./index.scss";

import {
	ITimerType,
	ILanguageType,
	IGameType,
	IUserdataType
} from "@/types/GlobalTypes";
import { getBasePcode, getGameVariantLetter } from "@/modules/gamePcode";

interface IProps {
	activeGame: IGameType;
	lang: ILanguageType;
	userdata: IUserdataType;
	timerData: ITimerType;
}

interface IState {
	useNewTimerInterface: boolean;
}

export default class RightSideButtons extends React.Component<IProps, IState> {
	state = { useNewTimerInterface: false }

	refreshCanvasInterval: number;

	canvasRef: HTMLCanvasElement;
	canvasRectangleSize = 200;

	componentDidMount() {
		if (this.state.useNewTimerInterface)
			window.setTimeout(() => {
				this.canvasRef = document.getElementById("timerArc") as HTMLCanvasElement;
				this.refreshArc();

				if (this.refreshCanvasInterval)
					window.clearInterval(this.refreshCanvasInterval);

				this.refreshCanvasInterval = window.setInterval(() => {
					this.refreshArc();
				}, 200);
			}, 100);
	}

	refreshArc() {
		if (!this.canvasRef) return;

		console.debug("RSB rA");

		const ctx = this.canvasRef.getContext("2d");

		const timeLeft = this.props.timerData.time,
			maxTimeLeft = this.props.timerData.timer;
		const mainColour = timeLeft <= 5 ? "#d52b2b" : "#00ff1e";

		ctx.clearRect(0, 0,
			this.canvasRectangleSize,
			this.canvasRectangleSize);

		ctx.shadowBlur = 8;
		ctx.shadowColor = mainColour;

		ctx.lineWidth = 20;
		ctx.strokeStyle = mainColour;

		if (timeLeft > 0) {
			ctx.beginPath();
			ctx.arc(
				this.canvasRectangleSize / 2,
				this.canvasRectangleSize / 2,
				this.canvasRectangleSize / 2 - 20,
				2 * Math.PI,
				getRadians(360 * (maxTimeLeft - timeLeft) / this.props.timerData.timer),
				true
			);
			// ctx.closePath();

			ctx.stroke();
		}
	}

	render() {
		const {
			activeGame,
			lang,
			userdata,
			timerData
		} = this.props;

		const betClosed = isBetClosed(timerData.time);
		const timeText = betClosed ? lang["txt_bet_closed"] : `${timerData.time}`;

		const timerClassName = (
			betClosed ? " bet-closed" :
				(timerData.time > 5) ? " bet-open" :
					" bet-closing"
		);

		return (
			<div className="right-side-button-container">
				<div className="group">
					<div className="desc-heading">
						{lang["txt_game_name_" + getBasePcode(activeGame.pcode)] + ` ${getGameVariantLetter(activeGame.pcode)}`}
						<br />
						<br />
						{lang["txt_round_id"] + " " + activeGame.periode}
					</div>
				</div>

				{
					this.state.useNewTimerInterface ? (
						<div className="group circle-timer">
							<div className="desc-heading">
								{
									betClosed ?
										lang["txt_wait_next_round"] :
										timerData.time > 5 ?
											lang["txt_place_bet"] :
											lang["txt_bet_close_in"]
								}
							</div>

							<div className={"timer-circle" + timerClassName}>
								<canvas id="timerArc" width="200" height="200"></canvas>

								<div className="timer-number">
									{timeText}
								</div>
							</div>
						</div>
					) : (
							<div className="group">
								<div className="desc-heading">
									{
										betClosed ?
											lang["txt_wait_next_round"] :
											timerData.time > 5 ?
												lang["txt_place_bet"] :
												lang["txt_bet_close_in"]
									}
								</div>

								<div className="timer-box patterned">
									<div className={"timer" + timerClassName}>
										{timeText}
									</div>
								</div>
							</div>
						)
				}

				<div className="group">
					<div className="desc-heading">
						{lang["txt_total_win"]}
					</div>
					<div className="patterned">
						{moneyFormat(activeGame.totalWin, userdata.user.lang, userdata.user.currency)}
					</div>

					<div className="desc-heading">
						{lang["txt_total_bet"]}
					</div>
					<div className="patterned">
						{moneyFormat(activeGame.totalBet, userdata.user.lang, userdata.user.currency)}
					</div>
				</div>
			</div>
		);
	}
}
